import React from "react";
import { Box, Card, CardHeader, CardContent, Typography, useTheme } from "@mui/material";
import { styles } from "../../styles/Vendors.styles";
import { getOwnerLabel } from "../../hooks/useVendorStaff";

const formatDateTime = (iso) =>
  new Date(iso).toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

const ActivityTab = ({ vendor, people = [] }) => {
  const theme = useTheme();
  const activity = [...(vendor.activity || [])].sort((a, b) => new Date(b.at) - new Date(a.at));
  const actorLabel = (actor) => {
    if (actor && actor.includes("@")) return getOwnerLabel(people, actor);
    return getOwnerLabel(people, vendor.owner);
  };

  return (
    <Card sx={styles.mainCard} variant="outlined">
      <CardHeader
        title={
          <Typography variant="h5" fontWeight="600" color={theme.customColors.text.strong}>
            Activity & Audit History
          </Typography>
        }
        sx={styles.cardHeader}
      />
      <CardContent>
        {activity.length === 0 ? (
          <Box sx={styles.emptyState}>
            <Typography variant="h5" color="textSecondary" sx={{ fontWeight: 600 }}>
              No activity recorded yet
            </Typography>
          </Box>
        ) : (
          <Box sx={{ position: "relative", pl: 3 }}>
            <Box
              sx={{
                position: "absolute",
                left: 6,
                top: 6,
                bottom: 6,
                width: "2px",
                backgroundColor: theme.customColors.border.main,
              }}
            />
            {activity.map((a) => (
              <Box key={a.id} sx={{ position: "relative", pb: 2.5, "&:last-of-type": { pb: 0 } }}>
                <Box
                  sx={{
                    position: "absolute",
                    left: -21,
                    top: 4,
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    backgroundColor: theme.customColors.button.primary,
                    border: `2px solid ${theme.customColors.background.main}`,
                    boxShadow: `0 0 0 2px ${theme.customColors.border.main}`,
                  }}
                />
                <Typography variant="body2" fontWeight={600} color={theme.customColors.text.strong}>
                  {a.action}
                </Typography>
                <Typography variant="caption">
                  {actorLabel(a.actor)} · {formatDateTime(a.at)}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default ActivityTab;
